import { render, staticRenderFns } from "./PromptLoginModal.vue?vue&type=template&id=4bf603b6"
import script from "./PromptLoginModal.vue?vue&type=script&lang=js"
export * from "./PromptLoginModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports